( function( $ ) {

  // Scrolling top nav with color change

  var prev = 0;
  var $window = $(window);
  var nav = $('.doc-header');

  $window.on('scroll', function(){
    var scrollTop = ($window.scrollTop() > 0 ? $window.scrollTop() : 0);
    var navHeight = $('.doc-header').outerHeight();
    nav.toggleClass('hidden', scrollTop > prev);
    prev = scrollTop;
    if ($(window).scrollTop() <= navHeight) {
      $(nav).removeClass('scrolling');
    } else {
      $(nav).addClass('scrolling');
    }

  });

  // Mobile Menu
  $('.js-hamburger').click(function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu-active');
  });

  $('.js-panel-trigger').click(function() {
    $(this).toggleClass('is-active');
    $('.js-panel').toggleClass('is-active');
  });

  $(document).ready(function() {
    var container = $('.work-list');
    
    // initialize Masonry after all images have loaded
    container.imagesLoaded(function() {
      container.masonry({
        itemSelector: '.work-list-item',
        columnWidth: '.work-list-item--spacer',
        percentPosition: true,
        gutter: 30,
      });
    });

    function toggleVisibility(elementToShow, elementToHide) {
        elementToShow.css('display', 'flex');
        elementToHide.css('display', 'none');
      }
    
      // Attach toggleCardForm function to card-info elements
      $('.card-info').click(function() {
        var cardInfoElement = $(this);
        var cardFormElement = cardInfoElement.next('.card-form');
        toggleVisibility(cardFormElement, cardInfoElement);
      });
    
      // Close card form and show card info
      $('.close-card-form').click(function() {
        var cardFormElement = $(this).closest('.card-form');
        var cardInfoElement = cardFormElement.prev('.card-info');
        toggleVisibility(cardInfoElement, cardFormElement);
      });
  });

  $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    var container = document.querySelector('.work-list');
    var msnry = new Masonry( container, {
      itemSelector: '.work-list-item',
      columnWidth: '.work-list-item--spacer',
      percentPosition: true,
      gutter: 30           
    });  
  });

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
  
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
  
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $( document ).ready(function() {
    var tags = $(".scroll-fade-in");
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if ($(tag).isInViewport()){
        $(tag).addClass("visible");
      }
    }
    $('.accordion').accordion({
      "transitionSpeed": 400
    });
    $('.menu-item-has-children > a').after('<svg class="menu-arrow" width="14px" height="14px" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41 0.579956L6 5.16996L10.59 0.579956L12 1.99996L6 7.99996L0 1.99996L1.41 0.579956Z" fill="currentColor"></path></svg>');
  });
  $(document).on("scroll", function() {
    var tags = $(".scroll-fade-in");
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if ($(tag).isInViewport()){
        $(tag).addClass("visible");
      }
    }
  });

  $('.tiny-js-image-slider-large').each(function() {
    tns({
      container: this,
      autoplay: true,
      autoplayButtonOutput: false,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      items: 1,
      mouseDrag: true,
      lazyload: true,
      responsive: {
        800: {
          edgePadding: 20,
          gutter: 20,
          items: 2
        },
        1100: {
          items: 3,
          gutter: 30
        },
        1480: {
          items: 4
        }
      }
    });
  });
  $('.tiny-js-image-slider-small').each(function() {
    tns({
      container: this,
      autoplay: true,
      autoplayButtonOutput: false,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      items: 2,
      mouseDrag: true,
      lazyload: true,
      responsive: {
        800: {
          edgePadding: 10,
          items: 3
        },
        1100: {
          items: 5,
        },
        1480: {
          items: 8,
        }
      }
    });
  });

  var colors = new Array(
    [106,20,209],
    [40,113,249],
    [106,20,209],
    [199,32,143],
    [40,113,249],
    [199,32,143]
  );
  
  var step = 0;
  //color table indices for: 
  // current color left
  // next color left
  // current color right
  // next color right
  var colorIndices = [0,1,2,3];
  
  //transition speed
  var gradientSpeed = 0.002;
  
  function updateGradient()
  {
    
    if ( $===undefined ) return;
    
  var c0_0 = colors[colorIndices[0]];
  var c0_1 = colors[colorIndices[1]];
  var c1_0 = colors[colorIndices[2]];
  var c1_1 = colors[colorIndices[3]];
  
  var istep = 1 - step;
  var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
  var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
  var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
  var color1 = "rgb("+r1+","+g1+","+b1+")";
  
  var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
  var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
  var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
  var color2 = "rgb("+r2+","+g2+","+b2+")";
  
   $('#gradient').css({
     background: "-webkit-gradient(linear, left top, right top, from("+color1+"), to("+color2+"))"}).css({
      background: "-moz-linear-gradient(left, "+color1+" 0%, "+color2+" 100%)"});
    
    step += gradientSpeed;
    if ( step >= 1 )
    {
      step %= 1;
      colorIndices[0] = colorIndices[1];
      colorIndices[2] = colorIndices[3];
      
      //pick two new target color indices
      //do not pick the same as the current one
      colorIndices[1] = ( colorIndices[1] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length;
      colorIndices[3] = ( colorIndices[3] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length;
      
    }
  }
  
  setInterval(updateGradient,10);
  

}( jQuery ) );